export function reduceHistory(state, action) {
  switch (action.type) {
    case 'HISTORY_LOADED':
      return Object.assign({}, state, {
        messages: action.messages,
        historyHasMore: action.hasMore,
        historyOffset: action.offset,
        isLoadingMore: false,
        messageTurnIdMap: action.turnIdMap,
        feedbackByTurnId: action.feedbackByTurnId,
        feedbackByCitationKey: action.feedbackByCitationKey
      }, action.agentId ? {
        agentId: action.agentId
      } : {});
    case 'AGENT_ID_SET':
      if (action.agentId === state.agentId) return state;
      return Object.assign({}, state, {
        agentId: action.agentId,
        defaultAgentId: action.agentId
      });
    case 'HISTORY_PAGE_LOADED':
      {
        const mergedMap = new Map([...state.messageTurnIdMap, ...action.turnIdMap]);
        const mergedFeedback = new Map([...state.feedbackByTurnId, ...action.feedbackByTurnId]);
        const mergedCitationFeedback = new Map([...state.feedbackByCitationKey, ...action.feedbackByCitationKey]);
        return Object.assign({}, state, {
          messages: [...action.messages, ...state.messages],
          historyHasMore: action.hasMore,
          historyOffset: action.offset,
          isLoadingMore: false,
          error: null,
          messageTurnIdMap: mergedMap,
          feedbackByTurnId: mergedFeedback,
          feedbackByCitationKey: mergedCitationFeedback
        });
      }
    case 'FEEDBACK_SUBMITTED':
      {
        if (action.citationId) {
          const citationKey = `${action.turnId}:${action.citationId}`;
          const updatedCitationFeedback = new Map(state.feedbackByCitationKey);
          updatedCitationFeedback.set(citationKey, action.feedbackType);
          return Object.assign({}, state, {
            feedbackByCitationKey: updatedCitationFeedback
          });
        }
        const updatedFeedback = new Map(state.feedbackByTurnId);
        updatedFeedback.set(action.turnId, action.feedbackType);
        return Object.assign({}, state, {
          feedbackByTurnId: updatedFeedback
        });
      }
    case 'FEEDBACK_REMOVED':
      {
        if (action.citationId) {
          const citationKey = `${action.turnId}:${action.citationId}`;
          const updatedCitationFeedback = new Map(state.feedbackByCitationKey);
          updatedCitationFeedback.delete(citationKey);
          return Object.assign({}, state, {
            feedbackByCitationKey: updatedCitationFeedback
          });
        }
        const updatedFeedback = new Map(state.feedbackByTurnId);
        updatedFeedback.delete(action.turnId);
        return Object.assign({}, state, {
          feedbackByTurnId: updatedFeedback
        });
      }
    case 'HISTORY_LOADING_MORE':
      return Object.assign({}, state, {
        isLoadingMore: action.loading
      });
    case 'HISTORY_INCREMENT_FETCH_ID':
      return Object.assign({}, state, {
        fetchIdCounter: state.fetchIdCounter + 1
      });
    case 'RESET':
      return Object.assign({}, state, {
        agentId: state.defaultAgentId,
        historyHasMore: false,
        historyOffset: undefined,
        isLoadingMore: false
      });
    default:
      return state;
  }
}